import { FelaCSS } from '../../../../components/fela/flowtypes';
import { colors } from '../../../../themes/variables';

interface IStyleTypes {
  wrapper: FelaCSS;
  name: FelaCSS;
  detailsWrap: FelaCSS;
  category: FelaCSS;
  town: FelaCSS;
}

const styles = (): IStyleTypes => ({
  wrapper: {
    paddingLeft: '13px',
    paddingRight: '13px',
    paddingTop: '8px',
    paddingBottom: '8px',
    marginTop: '4px',
    fontDefault: 14,
    lineHeight: '20px',
    cursor: 'pointer',
    textAlign: 'left',

    ':first-of-type': {
      marginTop: '0',
    },

    ':hover': {
      backgroundColor: colors.space04,
    },
  },

  name: {
    fontDefaultSemiBold: 'inherit',
    color: colors.space,
  },

  detailsWrap: {
    display: 'block',
    color: colors.space60,
  },

  category: {
    display: 'inline-block',
    wordBreak: 'break-word',
    fontDefault: 'inherit',
  },

  town: {
    display: 'inline-block',
    fontDefaultSemiBold: 'inherit',
  },
});

export default styles;
